// extracted by mini-css-extract-plugin
module.exports = {"arrow":"CarouselArrows_arrow__ILS1l","left":"CarouselArrows_left__3g-nb","right":"CarouselArrows_right__2mGa1"};